/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BaseSearchFilterElementDto } from './BaseSearchFilterElementDto';

export type DbtRunStatusSearchFilterElementDto = (BaseSearchFilterElementDto & {
    id?: DbtRunStatusSearchFilterElementDto.id;
});

export namespace DbtRunStatusSearchFilterElementDto {

    export enum id {
        SUCCESS = 'SUCCESS',
        ERROR = 'ERROR',
        SKIPPED = 'SKIPPED',
        PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
        REUSED = 'REUSED',
        WARN = 'WARN',
        NO_OP = 'NO_OP',
        UNKNOWN = 'UNKNOWN',
        NOT_TARGETED = 'NOT_TARGETED',
    }


}
